import { useSyncExternalStore } from 'react';

import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

// Singleton: one global `monitorForElements` subscription shared by all
// consumers so heavy lists cost one Pragmatic subscription instead of N.
let isActive = false;
const listeners = new Set<() => void>();
let cleanup: (() => void) | null = null;

function ensureMonitor(): void {
  if (cleanup) return;
  cleanup = monitorForElements({
    onDragStart: () => {
      if (isActive) return;
      isActive = true;
      listeners.forEach((listener) => listener());
    },
    onDrop: () => {
      if (!isActive) return;
      isActive = false;
      listeners.forEach((listener) => listener());
    }
  });
}

function subscribe(listener: () => void): () => void {
  ensureMonitor();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    // Monitor stays alive after listeners empties — view switches mount/unmount
    // consumers in bursts; keeping one global subscription avoids thrash.
  };
}

const getSnapshot = (): boolean => isActive;
const getServerSnapshot = (): boolean => false;

// True while any Pragmatic DnD drag is in flight; use to suppress hover-only
// UI (tooltips, overlays) since HTML5 DnD suppresses `mouseleave` mid-drag.
export function useIsAnyDragActive(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
